import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=eae449ae&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=eae449ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae449ae",
  null
  
)

export default component.exports